module.exports = __webpack_public_path__ + "media/images/gallery/solar_systems/maria_layer_off-e413cab46bf8c8f877ed2898487d6808.png";